import { render } from "./Hotkeys.vue?vue&type=template&id=06630ed7"
import script from "./Hotkeys.vue?vue&type=script&lang=js"
export * from "./Hotkeys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__